import { render } from "./ReverseLanguageNotification.vue?vue&type=template&id=5efae772"
import script from "./ReverseLanguageNotification.vue?vue&type=script&lang=js"
export * from "./ReverseLanguageNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__